<template>
  <div class="render_receive">
    <div class="list">
      客资姓名：<span>{{msgObject.kzName}}</span>
    </div>
    <div class="list">
      联系方式：<span>{{userContact}}</span>
    </div>
    <div class="list">
      录入人：<span style="margin-right:30px;">{{msgObject.collectorName}}</span>
      渠道：<span>{{msgObject.channelName}}</span>
    </div>
    <div class="list">
      录入时间：<span>{{createTime}}</span>
    </div>
    <div class="list">
      备注：<span>{{msgObject.memo}}</span>
    </div>
    <Button type="primary" style="float:right;" @click="receiveKz">领取</Button>
  </div>
</template>

<script>
  import timeUtil from '../../common/time-util'

  export default {
    name: "render-receive",
    props: {
      msgData: {
        type: Object,
      },
      userInfo:{
        type: Number,
      },
      contact:{
        type:String,
      },
      onlyId:{
        type:String,
      }
    },
    computed: {

      msgObject() {
        return this.msgData
      },
      createTime() {
        return timeUtil.getDate(this.msgData.createTime)
      },
      userContact(){
        return this.contact
      },
      onlyIdStr(){
        return this.onlyId
      }
    },
    methods: {
      receiveKz() {
        if (this.msgData.kzId) {
           this.$http.get('/app/pc_receive',{
             params:{
               staffId:this.userInfo,
               kzId:this.msgData.kzId,
             }
           }).then(data=>{
             if(data.code === 100000){
               this.$Message.success(data.msg)
               this.$Notice.destroy(this.onlyIdStr)
             }else{
               this.$Message.error(data.msg)
             }
           })
        } else {
          this.$Message.warning('客资ID不存在')
        }
      },
    }
  }
</script>

<style lang="less">
  .render_receive {
    .list {
      width: 320px;
      white-space: nowrap;
      overflow: hidden;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
      font-weight: 300;
      color: #333;
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/render-components/render-receive.vue